import { useEffect, useState } from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import styles from './PhoneAnimation.module.css';

const messages = [
  {
    id: 1,
    app: 'Recruiter · Email',
    text: 'Hi João, we saw your portfolio and would love to talk with you 🚀',
    icon: MdEmail,
  },
  {
    id: 2,
    app: 'LinkedIn',
    text: 'Someone just viewed your LinkedIn profile.',
    icon: FaLinkedin,
  },
  {
    id: 3,
    app: 'GitHub',
    text: 'New star on JoaoLopes017/portfolio ✨',
    icon: FaGithub,
  },
  {
    id: 4,
    app: 'Email',
    text: 'João, can we schedule a call this week?',
    icon: MdEmail,
  },
  {
    id: 5,
    app: 'You',
    text: 'Hey! Let’s build something awesome together.',
    icon: FaGithub,
  },
];

function PhoneAnimation() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
      setVisibleCount(prev =>
        prev < messages.length ? prev + 1 : prev
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const visibleMessages = [];
  for (let i = 0; i < visibleCount; i++) {
    const index = (currentIndex - i + messages.length) % messages.length;
    visibleMessages.push(messages[index]);
  }

  return (
    <div className={styles.phone}>
      <div className={styles.phoneShade} />
      <div className={styles.phoneSpeaker} />

      <div className={styles.phoneScreen}>
        <div className={styles.phoneHeader}>
          <div className={styles.phoneMenu} />
        </div>

        {visibleMessages.map((msg, index) => {
          const Icon = msg.icon;
          const isTop = index === 0;

          return (
            <div
              key={msg.id}
              className={[
                styles.phonePost,
                isTop ? styles.phonePostActive : '',
              ]
                .filter(Boolean)
                .join(' ')}>
              <div className={styles.postThumb}>
                <Icon className={styles.appIcon} />
              </div>

              <div className={styles.messageContent}>
                <p className={styles.messageTitle}>{msg.app}</p>
                <p className={styles.messageText}>{msg.text}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.phoneButton} />
    </div>
  );
}

export default PhoneAnimation;
